"use client";
import { Fragment, ReactNode, useEffect } from "react";

import MainComponent from "../MainComponent/MainComponent";
import { updateReduxStateActionInterface } from "@/commonJS/Actions/actionInterface";
type Props = {
  children: ReactNode;
  layouts: any;
  layoutScripts: any;
  locale: string;
  customClasses: string;
  device: "web" | "mobile";
  slug: string[];
  freshChatPages: string[];
};
import { getCookie } from "@/commonJS/clientStorageActions";
import dynamic from "next/dynamic";
const Loader = dynamic(() => import("../Loader/Loader"), { ssr: false });
import { debounce } from "@/commonJS/debounce";
import { useAppState } from "@/context/AppStateContext";
import createApiClient from "@/commonJS/api";
const FreshChat = dynamic(() => import("@/components/FreshChat/FreshChat"), {
  ssr: false,
});
// import { trackEvent } from "@/app/config/mixpanel";
// import mixpanel from "mixpanel-browser";
const PageLayout = ({
  children,
  layouts,
  layoutScripts,
  locale,
  customClasses,
  device = "web",
  slug,
  freshChatPages,
}: Props) => {
  // Validate params before fetching

  const {
    dispatch,
    state: { layoutStore },
  } = useAppState();
  const api = createApiClient();
  const isLandscapMode = () => {
    if (typeof window === "undefined") return false;
    return window.innerHeight < window.innerWidth && device === "mobile";
  };
  const setMobileViewport = debounce(
    () => {
      dispatch({
        type: "SET_REDUX_STATE",
        payload: {
          action: {
            actionType: "updateReduxState",
            reducer: "layout",
            update: {
              key: "isLanscape",
            },
          },
          payload: isLandscapMode(),
        },
      });
    },
    100,
    "deviceMode",
    true
  );
  const fetchProfile = async () => {
    try {
      const response = await api.get(
        `/profile?identifier=${getCookie("deviceId")}`,
        {
          headers: {
            Authorization: `Bearer ${getCookie("accessToken") ?? ""}`,
          },
        }
      );
      if (response.status === 401 || response.status === 403) {
        localStorage.clear();
        const reduxActionPayload: {
          action: updateReduxStateActionInterface;
          payload: any;
        } = {
          action: {
            actionType: "updateReduxState",
            reducer: "layout",
            update: {
              key: "profile",
            },
          },
          payload: null,
        };
        dispatch({
          type: "SET_REDUX_STATE",
          payload: reduxActionPayload,
        });
      } else if (response.status === 200) {
        const reduxActionPayload: {
          action: updateReduxStateActionInterface;
          payload: any;
        } = {
          action: {
            actionType: "updateReduxState",
            reducer: "layout",
            update: {
              key: "profile",
            },
          },
          payload: response.data.data,
        };
        dispatch({
          type: "SET_REDUX_STATE",
          payload: reduxActionPayload,
        });
      }
    } catch (error) {}
  };

  useEffect(() => {
    const token = getCookie("accessToken");
    
    if (token && token?.trim() !== "undefined" && token !== "undefined" && !layoutStore?.profile?.id) {
      fetchProfile();
    }
  }, []);

  useEffect(() => {
    window.addEventListener("resize", () => {
      setMobileViewport();
    });
    setMobileViewport();
  }, [device]);

  return (
    <Fragment>
      {customClasses && <style>{`${customClasses?.toString().trim()}`}</style>}

      <MainComponent
        json={layouts?.[0]?.data ?? []}
        isLayout={true}
        locale={locale}
        scripts={layoutScripts}
        layouts={layouts}
        key={"layoutMainComponent"}
        children={children}
      />

      {layoutStore?.loader?.is_common_loader && !layoutStore?.isLanscape && (
        <Loader field={{ fieldType: "loader" }} />
      )}
      {(freshChatPages ?? []).includes("/" + slug.join("/")) && (
        <FreshChat key={"freshchat"} />
      )}
    </Fragment>
  );
};

export default PageLayout;
